import React, { createContext, useContext, useState, useCallback } from 'react';
import '../../styles/notification.css';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const remove = useCallback((id) => {
    setNotifications((cur) => cur.filter((n) => n.id !== id));
  }, []);

  const notify = useCallback((message, type = 'info', options = {}) => {
    const duration = options.duration !== undefined ? options.duration : 5000;
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    setNotifications((cur) => [...cur, { id, message, type, duration }]);
    if (duration && duration > 0) {
      setTimeout(() => remove(id), duration);
    }
    return id;
  }, [remove]);

  return (
    <NotificationContext.Provider value={{ notify, remove }}>
      {children}

      <div className="notification-container" aria-live="polite" aria-atomic="true">
        {notifications.map((n) => (
          <div key={n.id} className={`notification notification--${n.type || 'info'}`}>
            <div className="notification-message">{typeof n.message === 'string' ? n.message : JSON.stringify(n.message)}</div>
            <button className="notification-close" onClick={() => remove(n.id)} aria-label="Dismiss notification">✕</button>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotification must be used within NotificationProvider');
  return ctx;
};

export default NotificationProvider;
